import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ApiService } from '../../services/api/api.service';

const name = 'CONFIGURATION';

export const createProfile = createAsyncThunk(`${name}/PROFILE`,
    async ({id, name, description, url, address, category}, thunkApi) => {
        try {
            const response = await ApiService.patch(`/vendor/admin/${id}`, {name, description, url, address, category});
            let data = await response.data;
            if (response.status === 200) {
                return data;
            }
            return thunkApi.rejectWithValue(data);
        } catch (e) {
            return thunkApi.rejectWithValue(e);
        }
    }
);

//to pewnie będzie w dashboardPayment
export const createInvoiceData = createAsyncThunk(`${name}/INVOICE`,
    async ({id, invoiceName, invoiceAddress, invoiceNip, invoicePostalCode, invoiceCity}, thunkApi) => {
        try {
            const response = await ApiService.patch(`/vendor/admin/${id}/invoice`, {invoiceName, invoiceAddress, invoiceNip, invoicePostalCode, invoiceCity});
            let data = await response.data;
            if (response.status === 200) {
                return data;
            }
            return thunkApi.rejectWithValue(data);
        } catch (e){
            return thunkApi.rejectWithValue(e);
        }
    }
);

//to powinno być przeniesione gdzieś wyżej bo dashboard też tego będzie potrzebował, np od razu po zalogowaniu
export const createVendorUsers = createAsyncThunk( `${name}/USERS`,
    async ({users: users, id: id}, thunkApi) => {
    try {
        const response = await ApiService.post(`/vendor/admin/${id}/users/users`, {users: users});
        let data = await response.data;
        if (response.status === 200) {
            return data;
        }
        return thunkApi.rejectWithValue(data);
    } catch (e){
        return thunkApi.rejectWithValue(e);
    }
}
);

const initialState = {
    profileData: undefined,
    invoiceData: undefined,
    vendorUsers: [],
    isFetching: false,
    isSuccess: false,
    isError: false,
    errorMessage: '',
};

export const configurationSlice = createSlice({
    name,
    initialState: initialState,
    reducers: {
        // czy tutaj coś powinno być ?
    },
    extraReducers: {
        [createProfile.fulfilled]: (state, { payload }) => {
            state.profileData = payload;
            state.isFetching = false;
            state.isSuccess = true;
            return state;
        },
        [createProfile.rejected]: (state, { payload }) => {
            state.isFetching = false;
            state.isError = true;
            state.errorMessage = payload?.message || '';
        },
        [createProfile.pending]: (state) => {
            state.isFetching = true;
        },
        [createInvoiceData.fulfilled]: (state, { payload }) => {
            state.invoiceData = payload;
            state.isFetching = false;
            state.isSuccess = true;
            return state;
        },
        [createInvoiceData.rejected]: (state, { payload }) => {
            state.isFetching = false;
            state.isError = true;
            state.errorMessage = payload?.message || '';
        },
        [createInvoiceData.pending]: (state) => {
            state.isFetching = true;
        },
        [createVendorUsers.fulfilled]: (state, { payload }) => {
            state.vendorUsers = payload;
            state.isFetching = false;
            state.isSuccess = true;
            return state;
        },
        [createVendorUsers.rejected]: (state, { payload }) => {
            state.isFetching = false;
            state.isError = true;
            state.errorMessage = payload?.message || '';
        },
        [createVendorUsers.pending]: (state) => {
            state.isFetching = true;
        },
    }
});
